<div class="border border-gray-200 rounded-lg text-sm">
  <div class="p-3 flex items-center bg-gray-100">
    <div class="flex gap-2 items-center flex-auto" cdkDragHandle>
      <mat-icon>remove_circle</mat-icon>

      <span class="font-medium">Stop interactie</span>
    </div>

    <div class="flex">
      <ng-template
        [ngTemplateOutlet]="actions() ?? null"
        [ngTemplateOutletContext]="{ $implicit: data() }"
      />
    </div>
  </div>
</div>
